import { useContext } from 'react'
import AppContext from '../config/context/app'

export const isOnCurrentCustomDomain = (
  team: Pick<wowaudit.TeamReference, 'id'> & {
    ownerReference: Pick<wowaudit.GuildReference, 'id'>
  },
  customDomain?: wowaudit.CustomDomain,
) => {
  if (!customDomain) return true
  if (customDomain.team) return customDomain.team.id === team.id

  return team.ownerReference.id === customDomain.guild.id
}

export const useCustomDomain = () => {
  const { customDomain, setCustomDomainPreview } = useContext(AppContext)

  return { customDomain, setCustomDomainPreview }
}
